<a [routerLink]="url">
  <logo *ngIf="!envIsZelis; else zelis" [compact]="true" [size]="24"></logo>
  <ng-template #zelis>
    <zelis-logo></zelis-logo>
  </ng-template>
</a>
